var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCopyWide = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.333 10.834a.333.333 0 0 0-.333.333v8c0 .184.15.334.333.334h8c.184 0 .334-.15.334-.334v-2.666a.333.333 0 0 0-.334-.334h-2.666a2.333 2.333 0 0 1-2.334-2.333v-2.667A.333.333 0 0 0 8 10.834H5.333ZM3 11.167a2.333 2.333 0 0 1 2.333-2.333H8a2.333 2.333 0 0 1 2.333 2.333v2.667c0 .184.15.333.334.333h2.666a2.333 2.333 0 0 1 2.334 2.334v2.666a2.333 2.333 0 0 1-2.334 2.334h-8A2.333 2.333 0 0 1 3 19.167v-8Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.334 5.833A2.333 2.333 0 0 1 10.667 3.5h8A2.333 2.333 0 0 1 21 5.833v8a2.333 2.333 0 0 1-2.333 2.334h-8a2.333 2.333 0 0 1-2.333-2.334v-8Zm2.333-.333a.333.333 0 0 0-.333.333v8c0 .184.149.334.333.334h8c.184 0 .333-.15.333-.334v-8a.333.333 0 0 0-.333-.333h-8Z",
    fill: "currentColor"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCopyWide);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/copy-wide.b6ce10e234848eecca5d084682f214ef.svg";